define([
    "./SensorConfigurationModule",
    "./SensorConfigurationRouter",
    "./SensorConfigurationEditionController",
    "./sensorConfigurationByDeviceModal"
], function () {
});